import { useMemo } from 'react';

import { useStockingCyclesController_list } from '@/services/hooks';

import { mapStockingCycleListToDomain } from './mappers';
import type { UseGetStockingCyclesResult } from './types';

/** The site's stocking cycles, newest first, with the backend's name prefill. */
export const useGetStockingCycles = (
    clientId: number,
    locationId: number
): UseGetStockingCyclesResult => {
    const query = useStockingCyclesController_list(clientId, locationId);

    const data = useMemo(
        () => (query.data?.data ? mapStockingCycleListToDomain(query.data.data) : null),
        [query.data?.data]
    );

    return {
        data,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
